import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useRoutes, useSearchParams } from 'react-router-dom';
import { groupApi } from '@/store/services/user-groups.service'; 
import { useGetGroupsQuery, useDeleteGroupMutation } from '@/store/services/user-groups.service';
import GroupList from './group-list';
import ConfirmationModal from './confirmation-modal';
import { CreateButton } from '@/shared/components/action-buttons';
import GroupDetail from './group-detail/group-detail';

const GroupManager = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page') || 1;
  const perPage = searchParams.get('per_page') || 10;

  const { data: response, error, isLoading, refetch } = useGetGroupsQuery({ 
    page: Number(page),
    per_page: Number(perPage)
  });

  const [deleteGroup] = useDeleteGroupMutation();
  const [groupToDelete, setGroupToDelete] = useState(null);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const handleCreateClick = () => {
    navigate('/users/groups/create');
  };

  const handleEditClick = (group) => {
    navigate(`/users/groups/edit/${group.id}`);
  };

  const handleDeleteClick = (groupId) => {
    setGroupToDelete(groupId);
    setIsConfirmationModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (groupToDelete) {
      try {
        await deleteGroup(groupToDelete).unwrap();

        dispatch(groupApi.util.invalidateTags([
          { type: 'Group', id: groupToDelete },
          'Group'
        ]));
        
        setGroupToDelete(null);
        setIsConfirmationModalOpen(false);
        
        if (window.location.pathname.includes(`/edit/${groupToDelete}`)) {
          navigate('/users/groups');
        }
      } catch (error) {
        console.error('Error eliminando grupo:', error);
        setIsConfirmationModalOpen(false);
      }
    }
  };

  const handleDeleteCancel = () => {
    setGroupToDelete(null);
    setIsConfirmationModalOpen(false);
  };

  if (isLoading) return <div>Cargando grupos...</div>;
  if (error) return <div>Error al cargar grupos: {error.message}</div>;

  const groups = response?.groups || [];
  const meta = response?.meta || {};

  const routes = useRoutes([
    {
      path: 'create',
      element: <GroupDetail />,
    },
    {
      path: 'edit/:id',
      element: <GroupDetail />,
    },
    {
      path: '',
      element: (
        <>
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold">Gestión de Grupos</h1>
            <div onClick={handleCreateClick}>
              <CreateButton />
            </div>
          </div>
          <GroupList
            groups={groups}
            meta={meta}
            onEdit={handleEditClick}
            onDelete={handleDeleteClick}
          />
          <ConfirmationModal
            isOpen={isConfirmationModalOpen}
            onClose={handleDeleteCancel}
            onConfirm={handleDeleteConfirm}
            message="¿Estás seguro de que deseas eliminar este grupo?"
          />
        </>
      ),
    },
  ]);

  return <div className="p-5">{routes}</div>;
};

export default GroupManager;